/** Bayanat Fleet Service Dashboard design tokens — aligned to enterprise shell. */

import { DASH, dashPageSx, dashCardSx } from "../../shared/dashboardEnterprise";

export const MD = {
  bg: DASH.bg,
  surface: DASH.surface,
  surface2: DASH.surface2,
  line: DASH.border,
  line2: "#eef0f3",
  fg: DASH.text,
  muted: DASH.muted,
  faint: DASH.faint,
  navy: DASH.navy,
  navy2: "#1d2c4f",
  brandGreen: "#10b981",
  link: "#2f80ed",
  good: "#16a34a",
  goodSoft: "#eafaf0",
  warn: "#f59e0b",
  warnSoft: "#fff6e8",
  bad: "#ef4444",
  badSoft: "#fdeeee",
  fontUi: DASH.font,
  fontHead: DASH.font,
  chart: [
    "#3b82f6",
    "#f59e0b",
    "#10b981",
    "#22c4dc",
    "#ef4444",
    "#8b5cf6",
    "#1b1f4b",
    "#94a3b8",
  ],
};

export const MD_KPI_TILES = {
  t1: {
    bgcolor: "#1d2c4f",
    color: "#fff",
    muted: "rgba(255,255,255,0.9)",
    meterTrack: "rgba(255,255,255,0.3)",
    meterBar: "#fff",
    infoTone: "onDark",
  },
  t2: {
    bgcolor: "#1565a8",
    color: "#fff",
    muted: "rgba(255,255,255,0.9)",
    meterTrack: "rgba(255,255,255,0.3)",
    meterBar: "#fff",
    infoTone: "onDark",
  },
  t3: {
    bgcolor: "#16adb8",
    color: "#fff",
    muted: "rgba(255,255,255,0.9)",
    meterTrack: "rgba(255,255,255,0.3)",
    meterBar: "#fff",
    infoTone: "onDark",
  },
  t4: {
    bgcolor: "#a5d6a7",
    color: "#1e4620",
    muted: "#1e4620",
    meterTrack: "rgba(30,70,32,0.18)",
    meterBar: "#1e4620",
    infoTone: "onLight",
  },
  t5: {
    bgcolor: "#fde3cc",
    color: "#c2410c",
    muted: "#c2410c",
    meterTrack: "rgba(194,65,12,0.15)",
    meterBar: "#ef4444",
    infoTone: "onLight",
  },
  t6: {
    bgcolor: "#f6ad55",
    color: "#5a2a06",
    muted: "#5a2a06",
    meterTrack: "rgba(90,42,6,0.18)",
    meterBar: "#8a3b0c",
    infoTone: "onLight",
  },
};

export const mdPageSx = {
  ...dashPageSx,
};

export const mdGridSx = (columns) => ({
  display: "grid",
  gap: "12px",
  width: "100%",
  gridTemplateColumns: columns,
});

export const MD_GRID = {
  kpis: {
    xs: "repeat(2, minmax(0, 1fr))",
    sm: "repeat(3, minmax(0, 1fr))",
    lg: "repeat(6, minmax(0, 1fr))",
  },
  row4: {
    xs: "minmax(0, 1fr)",
    sm: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(4, minmax(0, 1fr))",
  },
  three: {
    xs: "minmax(0, 1fr)",
    md: "repeat(3, minmax(0, 1fr))",
  },
  wide: {
    xs: "minmax(0, 1fr)",
    md: "minmax(0, 2fr) minmax(0, 1fr)",
  },
};

export const mdCardSx = {
  ...dashCardSx,
  display: "flex",
  flexDirection: "column",
  gap: 1,
  height: "100%",
  minWidth: 0,
  overflow: "hidden",
  p: "12px 14px",
  width: "100%",
};

/** Colored thin scrollbar for rank lists — matches enterprise shell */
export { dashScrollbarSx as mdScrollbarSx } from "../../shared/dashboardEnterprise";
